import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {ProfileComponent} from './components/profile/profile.component';
import {ProfileResetPasswordDialogComponent} from './components/profile/profile-reset-password/profile-reset-password-dialog.component';
import {ChangePasswordService} from './services/change-password.service';
@NgModule({
	imports: [
		SharedModule,
	],
	declarations: [
		ProfileComponent,
		ProfileResetPasswordDialogComponent
	],
	exports: [
		ProfileComponent
	],
	entryComponents: [
		ProfileResetPasswordDialogComponent
	],
	providers: [
		ChangePasswordService
	]
})

export class ProfileModule { }
